import React from 'react'
import Head from 'next/head'

import { ROBOTS_META } from 'const'

import Header from '../components/newHeader/Header'
import Footer from '../components/newFooter'
import styles from './tos.module.scss'

export default function CustomerFaq() {
  return (
    <div>
      <Head>
        {/*  Facebook tags  */}
        <meta
          name="og:title"
          content="Refund & Cancellation Policy | MawooPets.com"
          key="title"
        />
        <meta name="og:type" content="website" key="type" />
        <meta
          name="og:url"
          content={`${process.env.NEXT_PUBLIC_ROOT_URL}/refund-policy`}
          key="url"
        />
        <meta
          name="og:description"
          content="Review Mawoo Petsʼs comprehensive refund and cancellation policy."
        />
        <meta name="og:locale" content="en_US" key="locale" />
        {/*  standard tags  */}
        <title>Refund & Cancellation Policy | MawooPets.com</title>

        <meta
          name="description"
          content="Review Mawoo Petsʼs comprehensive refund and cancellation policy."
        />
        <meta name="robots" content={ROBOTS_META} />
        <link
          rel="canonical"
          href={`${process.env.NEXT_PUBLIC_ROOT_URL}/refund-policy`}
        />
      </Head>
      <Header />
      <main className={styles.main}>
        <h1 className={styles.title}>Refund & Cancellation Policy</h1>
        <p className="p1">
          <strong>Effective as of 6/20/2022</strong>
        </p>
        <p className="p1">
          Welcome to the Mawoo Pets Website (the “<strong>Website</strong>”),
          operated by Mawoo Pets Ltd. and Mawoo Pets LLC (collectively, “
          <strong>Mawoo Pets</strong>”, “<strong>we</strong>”, “
          <strong>our</strong>” and “<strong>us</strong>”).{' '}
        </p>
        <p className="p1">
          These terms govern all payments made by customers (“
          <strong>Customers</strong>”, “<strong>you</strong>”) that buy any
          product or service (collectively, “<strong>Products</strong>”) on our
          Website, whether directly from Mawoo Pets, or from one of our breeders
          (“<strong>Breeders</strong>”) who sell puppies on our Website.{' '}
        </p>

        <p className="p1">
          <strong>DEPOSIT & REMAINING PAYMENTS</strong>
        </p>

        <p className="p1">
          To purchase a puppy on our Website, a Customer must first make a
          deposit payment for that puppy. This payment secures the puppy
          exclusively for that Customer, making the puppy no longer available
          for purchase by any other Customer.{' '}
          <span className={styles.important}>
            As such, all deposit payments on Mawoo Pets are final and
            non-refundable.
          </span>
        </p>

        <p className="p1">
          All remaining payments, including for transportation fees to deliver
          the puppy from the Breeder to the Customer, must be made prior to the
          puppy’s departure from the Breeder’s place of residence. For Customers
          making this payment on our Website, all outstanding payments for the
          puppy must be paid by 1 business day before the puppy’s scheduled date
          of departure from the Breeder’s place of residence.{' '}
          <strong>Remaining payments are final and non-refundable.</strong>{' '}
        </p>

        <p className="p1">
          Customers who have arranged to make remaining payments directly to the
          breeder in cash can make such payments upon pickup of the puppy from
          the Breeder. In all cases, complete remaining payment must be received
          by Mawoo Pets or the Breeder before the puppy can leave the Breeder’s
          place of residence.
        </p>

        <p className="p1">
          In the event that a customer does not make complete remaining payment
          for the puppy by the required payment time, including for all
          associated transport fees, Mawoo Pets reserves the right to cancel the
          Customer’s purchase and process no refund for all payments made
          previously by the Customer for that puppy.{' '}
        </p>

        <p className="p1">
          {' '}
          <strong>
            If your chosen puppy is unavailable or unfit for sale, you may
            request a complete refund, including for all deposit and remaining
            payments, or to select a replacement puppy of equal or lesser value
            from our Website.
          </strong>{' '}
          A replacement puppy must be selected within 30 days of the date of
          notification of the original puppy’s unavailability. If no selection
          is made by such time, a refund of all deposit and remaining payments
          will be issued to the customer.{' '}
        </p>

        <p className="p1">
          The customer is responsible for receiving the puppy at the
          pre-determined date and time for pickup from the Breeder or commercial
          transporter. If the Customer is not able to pick up or receive the
          puppy at such time, the Customer forfeits their purchase, and the
          puppy may be returned to the breeder, without issuance of any refunds
          (for deposit or remaining payments) to the customer.{' '}
        </p>

        <p className="p1">
          <strong>TRAVEL TERMS</strong>
        </p>

        <p className="p1">
          The Customer is responsible for all costs to transport the puppy from
          the Breeder’s place of residence to the Customer. No puppy on our
          Website will depart the Breeder’s place of residence before reaching 8
          (eight) weeks of age and 2 (two) pounds of weight. Breeders reserve
          the right to wait until 10 weeks of age before releasing the puppy to
          the Customer, whether for pickup or transportation.
        </p>

        <p className="p1">
          Mawoo Pets waives all liability associated with the safety of the
          puppy while in commercial transit to the Customer’s place of
          residence, including any and all incurred injuries as a result of
          transportation accidents.{' '}
        </p>

        <p className="p1">
          <strong>HEALTH GUARANTEE & RETURN POLICY </strong>
        </p>

        <p className="p1">
          Mawoo Pets certifies that your puppy has been examined by a licensed
          veterinarian and is in good health at the time of leaving the
          Breeder’s place of residence. A Health Record is provided for each
          puppy purchased on Mawoo Pets, which shows vaccinations, deworming,
          medications, etc. received by the puppy while in the Breeder’s care.
        </p>

        <p className="p1">
          <span className={styles.underline}>
            You must take the puppy to a licensed veterinarian within 3 business
            days of receiving the puppy.
          </span>{' '}
          Any health warranty, whether provided by the Breeder’s Health
          Guarantee, or otherwise by Mawoo Pets, is void if the Customer fails
          to have a veterinary inspection performed.
        </p>

        <p className="p1">
          If any issues are identified during this veterinary inspection, the
          Customer must share written evidence of the veterinarian’s findings
          within 1 business day with Mawoo Pets. At such a time, the Customer is
          eligible for monetary refunds for veterinary expenses up to the
          purchase price of the puppy, or can instead request a replacement
          puppy from Mawoo Pets. <br />
          Some puppies on Mawoo Pets are additionally covered by a Health
          Guarantee provided by the Breeder. This Health Guarantee is disclosed
          to the Customer at the time of purchase, and can be viewed on the
          puppy’s public profile on Mawoo Pets. The terms of the Health
          Guarantee vary by Breeder, and the Customer must review these terms to
          determine if their puppy is eligible for any additional coverage. To
          be eligible for participating in a Health Guarantee, the Customer must
          provide evidence of veterinary inspection within 3 business days of
          receiving the puppy. In the absence of such evidence, the Customer
          forfeits the right to any monetary refunds, even if the puppy’s health
          issues are otherwise covered by the Health Guarantee.
        </p>

        <p className="p1">
          No guarantees are provided by Mawoo Pets regarding the puppy’s
          eventual size, color, or temperament. Additionally, Mawoo Pets will
          not accept any returns of the puppy for monetary refund for reasons
          unrelated to the puppy’s health, such as allergies, landlord/tenant
          restrictions, marital issues, puppy adjustment problems or any other
          such reasons.
        </p>

        <p className="p1">
          In the event the Customer is unable or unwilling to care for the puppy
          at any time during the puppy's life, the Customer agrees to contact
          Mawoo Pets for assistance on the puppy’s rehoming. If the Customer
          must return the puppy for any reason, this return will not be subject
          to any refund or credits for the Customer, and the Customer will be
          responsible for all travel-related costs to deliver the puppy to
          his/her new home.
        </p>
      </main>
      <Footer />
    </div>
  )
}
